import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const AerodynamicForceCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-aerodynamic-force-calculator" />;

export default AerodynamicForceCalculatorGuidePage;
